module.exports = __webpack_public_path__ + "static/media/vertical_option_desktop.80f41f48.jpg";